<template>
  <form>
    <v-row
      align="center"
      justify="center"
    >
      <span
        v-show="invitedTeam.invitationCode.length > 0"
        class="title white--text my-6"
      >
        {{ $t('msg.teamInvitation', { team: invitedTeam.name }) }}
      </span>
    </v-row>
    <v-row
      align="center"
      justify="center"
      class="mt-6"
    >
      <v-btn
        color="secondary"
        type="submit"
        @click.prevent="acceptInvitation"
      >
        {{ $t('msg.acceptInvitation') }}
      </v-btn>
    </v-row>
  </form>
</template>

<script>
export default {
    data() {
        return {
            invitedTeam: {
                name: '',
                id: '',
                invitationCode: '',
            },
        };
    },
    created() {
        if (typeof this.$store.getters.invitedTeam !== 'undefined') {
            this.invitedTeam.name = this.$store.getters.invitedTeam.name;
            this.invitedTeam.id = this.$store.getters.invitedTeam.id;
            this.invitedTeam.invitationCode = this.$store.getters.invitedTeam.invitationCode;
        }
    },
    methods: {
        acceptInvitation() {
            this.$rq.postAcceptTeamInvitation(this.invitedTeam.id, this.invitedTeam.invitationCode)
                .then(() => {
                    this.$toasted.global.toast_success({
                        message: this.$t('msg.invitationAccepted', { team: this.invitedTeam.name }),
                    });
                    this.redirect();
                });
        },
        redirect() {
            this.$router.push({ name: 'login' });
        },
    },
};
</script>
